import React, { useState } from 'react';
import Lottery from './components/Lottery';
import Voting from './components/Voting';
import './App.css';

function App() {
  const [currentView, setCurrentView] = useState('lottery'); // lottery, voting

  const renderView = () => {
    switch (currentView) {
      case 'lottery':
        return <Lottery />;
      case 'voting':
        return <Voting />;
      default:
        return <Lottery />;
    }
  };

  return (
    <div className="App">
      <div className="container">
        <div className="main-content">
          <div className="navigation-menu">
            <button 
              className={`nav-btn ${currentView === 'lottery' ? 'active' : ''}`}
              onClick={() => setCurrentView('lottery')}
            >
              🎰 抽奖
            </button>
            <button 
              className={`nav-btn ${currentView === 'voting' ? 'active' : ''}`}
              onClick={() => setCurrentView('voting')}
            >
              🗳️ 投票
            </button>
          </div>

          <div className="view-content">
            {renderView()}
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
